module.exports = __webpack_public_path__ + "img/brand-block-9.8dfe9fa3.png";